import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-review-reason-modal',
  templateUrl: './review-reason-modal.component.html',
  styleUrl: './review-reason-modal.component.scss',
})
export class ReviewReasonModalComponent {
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<ReviewReasonModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      action: 'accept' | 'reject';
      title: string;
      message: string;
      confirmButtonText?: string;
      cancelButtonText?: string;
      reasonLabel?: string;
    }
  ) {}

  get confirmLabel(): string {
    return (
      this.data.confirmButtonText ??
      (this.data.action === 'accept' ? 'Accept' : 'Reject')
    );
  }

  get cancelLabel(): string {
    return this.data.cancelButtonText ?? 'Cancel';
  }

  get reasonFieldLabel(): string {
    return this.data.reasonLabel ?? 'Reason (Optional)';
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      reason: this.reason?.trim() || undefined,
    });
  }
}
